import React from 'react'

import { ContentWithOffset } from '../../components/scharedStyles/style'
import AboutDevelopersList from './AboutDevelopersList'
import AboutDevelopersSidebar from './AboutDevelopersSidebar'
import { PageLayout } from './style'

const AboutDevelopers = () => (
    <ContentWithOffset>
        <PageLayout>
            <AboutDevelopersSidebar />
            <AboutDevelopersList />
        </PageLayout>
    </ContentWithOffset>
)

export default AboutDevelopers
